import { BaseProps } from '@/components/types'
import { Button as MuiButton, useMediaQuery } from '@mui/material'
import { AppBar, Button, HomeLayout, Icon, SideMenu, SwipeableMenu, Toolbar } from '@/components'
import { CSSProperties, MouseEvent, useCallback, useState } from 'react'
import '@/assets/scss/app/header.scss'
import { useNavigate } from 'react-router-dom'
import { useAxiosGet, useSession } from '@/hooks'
import { HEADER_HEIGHT, MEDIA_QUERY, MAX_WIDTH } from '@/constants/style'
import useStore from '@/store'
import useLayoutStore from '@/store/layout'
import HeaderMenu from './HeaderMenu'
import logoSvg from '@/assets/img/logo.svg'


function Header ( props: HeaderProp ) {
    const matches = useMediaQuery( MEDIA_QUERY )
    const { title, headerWidth, headerMinWidth = MAX_WIDTH, hideMenuButton } = props
    const navigator = useNavigate()
    const axiosGet = useAxiosGet()
    const session = useSession()
    const { isMobile } = useLayoutStore()
    const { isLogin, setIsLogin, setSession } = useStore()
    const [ openDrawer, setOpenDrawer ] = useState( false )
    const minWidth = screen.availWidth < headerMinWidth ? screen.availWidth : headerMinWidth

    const getHeaderStyle: () => CSSProperties = () => {
        const headerStyle: CSSProperties = {}
        if ( !matches ) {
            headerStyle.minWidth = minWidth
            headerStyle.maxWidth = screen.availWidth * ( headerWidth / 100 || 0.6 )
        }
        return headerStyle
    }

    const toggleDrawer = () => {
        setOpenDrawer( !openDrawer )
    }

    const onRegister = useCallback( () => {
        navigator( '/regist' )
    }, [] )

    const onLogin = useCallback( () => {
        navigator( '/login' )
    }, [] )

    const onAccount = useCallback( () => {
        navigator( '/user/detail', { state: { id: session( 'id' ), isAccount: true, title: '계정 정보' } } )
    }, [] )

    const onLogout = useCallback( async () => {
        await axiosGet( `/api/v1/auth/logout/${session( 'id' )}` )
        setIsLogin( false )
        setSession( null )
        navigator( '/' )
    }, [ session ] )

    const onClickLogo = useCallback( ( e: MouseEvent<HTMLImageElement> ): void => {
        navigator( '/' )
    }, [] )
    const iconSx: CSSProperties = {
        fontSize: '2rem'
    }

    return (
        <div className='header'>
            <div
                className='header-wrapper'
                style={ getHeaderStyle() }
            >
                <AppBar
                    sx={ {
                        height: HEADER_HEIGHT,
                        backgroundColor: 'white',
                        border: 'none',
                        boxShadow: 'none'
                    } }
                    position="static"
                >
                    <Toolbar sx={ { height: '100%', pl: 1.5, pr: 2.5 } }>
                        { ( isLogin || isMobile ) &&
                            <MuiButton
                                className="icon-color"
                                onClick={ toggleDrawer }
                            >
                                <Icon sx={ iconSx }>menu</Icon>
                            </MuiButton>
                        }
                        <div>
                            <img
                                src={ logoSvg }
                                style={{
                                    width: '90px',
                                    height: '70px',
                                    cursor: 'pointer',
                                    marginRight: '40px'
                                }}
                                onClick={ onClickLogo }
                            />
                        </div>
                        {
                            !isMobile && <HeaderMenu
                                menuDatas={ [
                                    {
                                        menudId: 'review',
                                        menuName: '물건 접수',
                                        onClick: () => {
                                            navigator( '/review/accepts' )
                                        }
                                    },
                                    {
                                        menudId: 'loanSim',
                                        menuName: '대주 추천',
                                        onClick: () => {
                                            navigator( '/review/loanSim' )
                                        }
                                    },
                                    {
                                        menudId: 'appraisal',
                                        menuName: '탁감하기',
                                        onClick: () => {
                                            navigator( '/review/appraisal' )
                                        }
                                    }
                                ] }
                            />
                        }
                        {
                            isLogin ?
                                <MuiButton
                                    className="icon-color"
                                    sx={ {
                                        height: '30px',
                                        marginLeft: 'auto',
                                        px: 2,
                                    } }
                                    onClick={ onLogout }
                                >
                                    로그아웃
                                </MuiButton> :
                                <>
                                    <MuiButton
                                        className="icon-color"
                                        sx={ {
                                            height: '30px',
                                            marginLeft: 'auto',
                                            px: 2,
                                        } }
                                        onClick={ onRegister }
                                    >
                                        회원가입
                                    </MuiButton>
                                    <MuiButton
                                        className="icon-color"
                                        sx={ {
                                            height: '30px',
                                            px: 2,
                                        } }
                                        onClick={ onLogin }
                                    >
                                        로그인
                                    </MuiButton>
                                </>
                        }
                        <SwipeableMenu
                            anchor="left"
                            open={ openDrawer }
                            setOpen={ ( open ) => setOpenDrawer( open ) }
                        >
                            <SideMenu/>
                        </SwipeableMenu>

                    </Toolbar>
                </AppBar>

            </div>
        </div>
    )
}

export default Header

export interface HeaderProp extends BaseProps {
    title?: string
    hideMenuButton?: boolean
    contentWidth?: number
    headerMinWidth?: number
    headerWidth?: number
}
